import React from 'react';
import { CTAButton } from './CTAButton';
export function UrgencyClose() {
  return <section className="bg-primary-dark py-[80px] px-[40px] text-center" data-id="element-529">
      <div className="max-w-[640px] mx-auto" data-id="element-530">
        <p className="font-sans text-[12px] font-bold text-gold-accent tracking-[0.3em] uppercase mb-6" data-id="element-531">
          ⏰ WHY THIS MATTERS TONIGHT
        </p>

        <h2 className="font-serif text-[36px] md:text-[44px] text-cream-light mb-8 leading-tight" data-id="element-532">
          Every Week You Wait,
          <br data-id="element-533" />
          <span className="italic text-gold-accent" data-id="element-534">The Debt Compounds.</span>
        </h2>

        <div className="font-sans text-[18px] text-cream-light/70 leading-[2] mb-12" data-id="element-535">
          <p className="mb-6" data-id="element-536">
            On a $10,000 credit card balance at 22% APR —<br data-id="element-537" />
            you pay $183 in interest this month alone.
          </p>
          <p className="font-bold text-cream-light mb-6" data-id="element-538">
            That's $183 that could have gone toward the debt itself.
            <br data-id="element-539" />
            That's $183 that pays for this system 18 times over.
            <br data-id="element-540" />
            That's $183 you will never see again.
          </p>
          <p data-id="element-541">
            Next month: another $183.
            <br data-id="element-542" />
            The month after: another $183.
            <br data-id="element-543" />
            This is not a problem that gets better with time.
            <br data-id="element-544" />
            It gets WORSE with time. By design.
          </p>
        </div>

        <div className="bg-gold-accent/10 border border-gold-accent/30 rounded-xl p-[32px_40px] max-w-[580px] mx-auto" data-id="element-545">
          <p className="font-sans text-[17px] text-cream-light mb-4" data-id="element-546">
            The system exists right now.
            <br data-id="element-547" />
            The scripts are written.
            <br data-id="element-548" />
            The tools are ready.
          </p>
          <p className="font-sans font-bold text-[20px] text-gold-accent" data-id="element-549">
            The only question is whether you start tonight
            <br data-id="element-550" />
            or pay another month of interest first.
          </p>
        </div>

        <div className="mt-12" data-id="element-551">
          <CTAButton subText="Every day costs you $6 in interest · Start now" data-id="element-552">
            STOP PAYING INTEREST — START TONIGHT → $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}